import { render, staticRenderFns } from "./myVol.vue?vue&type=template&id=73f7ba36&scoped=true"
import script from "./myVol.vue?vue&type=script&lang=js"
export * from "./myVol.vue?vue&type=script&lang=js"
import style0 from "./myVol.vue?vue&type=style&index=0&id=73f7ba36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f7ba36",
  null
  
)

export default component.exports